import Vue from 'vue';
import Vuex from 'vuex';

// these are store of root
import state from './states';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

// load all of index.js in modules dir
const modules = {};
const files = require.context('./modules', true, /^\.\/(\w*\/)+index\.js$/);
files.keys().forEach(file => {
  const moduleName = file.replace(/(^\.\/)|(\/index\.js$)/g, '');
  modules[moduleName] = files(file).default || files(file);
});


export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules
});
